import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Stack from 'components/core/Stack';
import Input from 'components/core/Input';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';

import lookupTableActions from 'actions/lookupTableActions';
import LookupTableUtils from 'utils/LookupTableUtils';

const LookupTableForm = ({ onSubmit, className, initialValues }) => {
    const dispatch = useDispatch();
    const [lookupTable, setLookupTable] = useState({
        label: initialValues?.get?.('label') || initialValues?.label || '',
        shortCode: initialValues?.get?.('shortCode') || initialValues?.shortCode || '',
        description: initialValues?.get?.('description') || initialValues?.description || '',
        examples: initialValues?.get?.('examples') || initialValues?.examples || ''
    });
    const [errors, setErrors] = useState({});

    const fieldLabels = {
        label: 'Label',
        shortCode: 'Short Code',
        description: 'Description',
        examples: 'Examples'
    };

    const table = LookupTableUtils.lookupTableClasses.find(tc => tc.className === className);
    if (!table) {
        return <Typography color="error">Error: Invalid lookup table class name "{className}"</Typography>;
    }

    const lookupTableFields = table.fields;

    const handleSave = async () => {
        setErrors({});

        try {
             
            if (!lookupTable.label) {
                setErrors(prev => ({ ...prev, label: 'Label is required.' }));
                return;
            }

            if (!lookupTable.shortCode) {
                setErrors(prev => ({ ...prev, shortCode: 'Short Code is required.' }));
                return;
            }

            const lookupTableData = {
                className,
                objectId: initialValues?.id || initialValues?.get?.('id'),
                label: lookupTable.label,
                shortCode: lookupTable.shortCode,
                description: lookupTable.description,
                examples: lookupTable.examples
            };

            const savedEntry = await dispatch(lookupTableActions.save(lookupTableData));
            await dispatch(lookupTableActions.fetchAllOptions());
            onSubmit(savedEntry.value);
        } catch (err) {
            setErrors({ submit: err.message });
        }
    };

    const handleFieldChange = (field, value) => {
        setLookupTable(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <Stack spacing={4}>
            {lookupTableFields.map((field) => (
                <Input
                    key={field}
                    label={fieldLabels[field] || field}
                    value={lookupTable[field]}
                    onChange={(value) => handleFieldChange(field, value)}
                    error={errors[field]}
                    multiline={field === 'description' || field === 'examples'}
                    rows={field === 'description' ? 3 : field === 'examples' ? 2 : 1}
                />
            ))}

            {errors.submit && (
                <Typography style={{color: 'red'}}>{errors.submit}</Typography>
            )}

            <Button onClick={handleSave}>
                {initialValues ? 'Update' : 'Create'} {className}
            </Button>
        </Stack>
    );
};

LookupTableForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    initialValues: PropTypes.object
};

export default LookupTableForm;